export const DELETE_SLIDE_REQUEST = " DELETE_SLIDE_REQUEST";
export const DELETE_SLIDE_SUCCESS = " DELETE_SLIDE_SUCCESS";
export const DELETE_SLIDE_FAILURE = " DELETE_SLIDE_FAILURE";
